import React from 'react'
import OrderPlaced from '../components/cart/orderPlaced'
import Navbar from '../components/common/navbar'
import Footer from '../components/common/footer'

const OrderPlacePage = () => {
  return (
    <div>
        <div>
        <Navbar/>
        <div className="md:mx-16 mx-4"><OrderPlaced/></div>
        
        <Footer />
    </div>
    </div>
  )
}

export default OrderPlacePage